import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface BudgetStatsCardProps {
  title: string;
  amount: number;
  currency: string;
  growthRate?: number;
  className?: string;
}

export const BudgetStatsCard = ({ 
  title, 
  amount, 
  currency, 
  growthRate, 
  className 
}: BudgetStatsCardProps) => {
  return (
    <Card className={`transition-transform hover:scale-105 ${className}`}>
      <CardHeader>
        <div className="flex items-center gap-2">
          <CardTitle className="text-white">{title}</CardTitle>
          {title.includes("Moyenne") && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <Info className="h-4 w-4 text-white/80 hover:text-white transition-colors" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>Cette moyenne est calculée en divisant le montant total des ventes par le nombre de transactions effectuées sur la période.</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-2xl font-bold text-white">
          {amount.toLocaleString()} {currency}
        </p>
        {growthRate !== undefined && (
          <p className={`text-sm mt-2 ${growthRate >= 0 ? 'text-green-200' : 'text-red-200'}`}>
            {growthRate >= 0 ? '↑' : '↓'} {Math.abs(growthRate).toFixed(1)}% vs mois précédent
          </p>
        )}
      </CardContent>
    </Card>
  );
};